import { safeUrl } from '../../../blockConfig';

// Carousel behaviour: current slide, autoplay lifecycle, touch swipe and safe
// slide normalization. Kept out of the component so the SFC stays presentational.
const MIN_INTERVAL_MS = 1500;
const SWIPE_THRESHOLD_PX = 40;

export default {
  props: {
    config: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      currentIndex: 0,
      touchStartX: null,
      autoplayTimer: null,
    };
  },
  computed: {
    slides() {
      const slides = this.config && this.config.slides;
      if (!Array.isArray(slides)) return [];
      return slides.map(slide => ({
        image: safeUrl(slide.image),
        title: slide.title || '',
        description: slide.description || '',
        link: safeUrl(slide.link),
      }));
    },
    showIndicators() {
      return this.config.showIndicators !== false && this.slides.length > 1;
    },
    showNavigation() {
      return this.config.showNavigation !== false && this.slides.length > 1;
    },
    autoplayInterval() {
      const interval = Number(this.config.interval);
      return Number.isFinite(interval) && interval >= MIN_INTERVAL_MS
        ? interval
        : MIN_INTERVAL_MS;
    },
  },
  mounted() {
    this.startAutoplay();
  },
  beforeDestroy() {
    this.stopAutoplay();
  },
  methods: {
    goTo(index) {
      const count = this.slides.length;
      if (!count) return;
      this.currentIndex = (index + count) % count;
    },
    next() {
      this.goTo(this.currentIndex + 1);
    },
    prev() {
      this.goTo(this.currentIndex - 1);
    },
    startAutoplay() {
      if (this.config.autoplay !== true || this.slides.length <= 1) return;
      this.stopAutoplay();
      this.autoplayTimer = setInterval(this.next, this.autoplayInterval);
    },
    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    },
    onTouchStart(event) {
      this.touchStartX = event.changedTouches[0].clientX;
    },
    onTouchEnd(event) {
      if (this.touchStartX === null) return;
      const deltaX = event.changedTouches[0].clientX - this.touchStartX;
      if (Math.abs(deltaX) >= SWIPE_THRESHOLD_PX) {
        if (deltaX < 0) this.next();
        else this.prev();
      }
      this.touchStartX = null;
    },
  },
};
